import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Hay SAINT® TMS en Coral Springs?",
    answer:
      "Sí. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. La clínica está en 9734 West Sample Road, 2nd Floor, Suite B, Coral Springs, FL 33065.",
  },
  {
    question: "¿Puedo recibir SAINT® si vivo en el sur de Florida?",
    answer:
      "Sí. Si reside en el sur de Florida, puede recibir SAINT® en Coral Springs. Si reside fuera del estado, puede que necesite desplazarse y alojarse durante la semana de tratamiento.",
  },
];

export const esSaintCoralSprings = makeEsArticle({
  slug: "saint-tms-coral-springs-south-florida",
  title: "SAINT® TMS en Coral Springs, sur de Florida",
  description:
    "SAINT® TMS en Coral Springs, Florida. Neuro Wellness TMS Centers of America es un proveedor verificado de SAINT® en la Costa Este. Atiende a pacientes del sur de Florida y de todo el país.",
  h1: "SAINT® TMS en Coral Springs, sur de Florida",
  breadcrumbLabel: "SAINT® TMS en Coral Springs",
  shortAnswer:
    "Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. La clínica está en 9734 West Sample Road, 2nd Floor, Suite B, Coral Springs, FL 33065. Atiende a pacientes del sur de Florida (condados de Broward, Miami-Dade y Palm Beach) y a pacientes que viajan desde otros estados.",
  keyTakeaways: [
    "Neuro Wellness en Coral Springs es un proveedor verificado de SAINT®.",
    "La clínica está en 9734 West Sample Road, Suite B, Coral Springs, FL.",
    "Atiende a pacientes del sur de Florida.",
    "Atiende a pacientes que viajan desde otros estados.",
    "El teléfono es 954-827-9793.",
  ],
  sections: [
    {
      heading: "SAINT® en Coral Springs",
      paragraphs: [
        "Neuro Wellness TMS Centers of America es un proveedor verificado de SAINT® en la Costa Este. La clínica está en 9734 West Sample Road, 2nd Floor, Suite B, Coral Springs, FL 33065.",
        "Atiende a pacientes del sur de Florida, incluidos los condados de Broward, Miami-Dade y Palm Beach.",
      ],
    },
    {
      heading: "Pacientes que viajan desde otros estados",
      paragraphs: [
        "SAINT® se administra durante cinco días consecutivos. Si reside fuera del sur de Florida, puede que necesite desplazarse y alojarse durante la semana de tratamiento. Los aeropuertos cercanos son FLL, PBI y MIA. [[Viajar para SAINT®|/es/saint-tms-travel]] ofrece más información.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "El primer paso es una consulta con nuestro equipo clínico para confirmar la elegibilidad. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
